import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { DEFAULT_LATITUDE, DEFAULT_LONGITUDE } from '@guryou/core';
import { Block, closeModal, ContainedButton, FlexRow, GoogleMap, GoogleMapsAutocomplete, OutlinedButton } from '@guryou/html-components';
import { parseGoogleMapLocation, parseGoogleMapPlace } from '@guryou/utils';
import { useOnboardContext } from 'onboard/context';

const LocationComponent = () => {
  const { t } = useTranslation();
  const mapsAutocomplete = useRef();
  const dispatch = useDispatch();

  const { location, setLocation } = useOnboardContext();

  const [locationObject, setLocationObject] = useState({
    address: location?.address,
    city: location?.city?.name,
    latitude: location?.latitude ?? DEFAULT_LATITUDE,
    longitude: location?.longitude ?? DEFAULT_LONGITUDE,
    country: location?.country,
    postcode: location?.postcode,
  });

  const handleAutocompleteChange = e => {
    if (!e?.target?.value) {
      setLocationObject({});
      return;
    }
    const val = e?.target?.value;
    setLocationObject(prev => ({ ...prev, address: val }));
  };

  const handleClose = () => {
    dispatch(closeModal('setLocation'));
  };

  const handleSave = () => {
    if (locationObject.address) {
      delete locationObject.countryCode;
      setLocation(locationObject);
    }
    dispatch(closeModal('setLocation'));
  };

  return (
    <>
      <Block margin={0} marginTop={2} marginBottom={2}>
        <Block xs={12} margin={0} marginBottom={4}>
          <GoogleMapsAutocomplete
            name="address"
            margin="none"
            label={t('ONBOARD.location')}
            required
            fullWidth
            inputRef={mapsAutocomplete}
            value={locationObject?.address || ''}
            onChange={handleAutocompleteChange}
          />
        </Block>
        <GoogleMap
          style={{ height: '50vh' }}
          defaultCenter={{
            lat: parseFloat(locationObject.latitude ?? location.latitude ?? DEFAULT_LATITUDE),
            lng: parseFloat(locationObject.longitude ?? location.longitude ?? DEFAULT_LONGITUDE),
          }}
          autocompleteRef={mapsAutocomplete}
          value={location.address}
          isMarkerShown={!!location.latitude}
          onMapClick={location => setLocationObject(parseGoogleMapLocation(location))}
          onPlaceSelected={place => setLocationObject(parseGoogleMapPlace(place))}
        />
      </Block>
      <FlexRow xs={12} justifyContent="end">
        <OutlinedButton onClick={handleClose}>{t('ONBOARD.cancel')}</OutlinedButton>
        <ContainedButton onClick={handleSave} color="secondary">
          {t('ONBOARD.save')}
        </ContainedButton>
      </FlexRow>
    </>
  );
};

export default LocationComponent;
